module.exports = "https://dashboard.cdn.gifty.nl/6303/images/gifty-logo-light.png?3ef127ce0af1e3a1116c23f122a81b28";